import FeedbackButton from './FeedbackButton';
import FeedbackModal from './FeedbackModal';
import PopUpSurvey from './PopUpSurvey';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { FeedbackContext } from './FeedbackContext';

export default function FeedbackContainer({ hideContainer }) {
  const { passedAppFunctions, state } = useContext(AppContext);
  const { open, isStoreFeedback, handleOpenFeedbackModal } = useContext(FeedbackContext);
  const { siteFormat } = passedAppFunctions;

  const showFeedbackTab = passedAppFunctions.wasParms.showFeedbackTab === 'true';

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    const feedbackButton = document.getElementById('feedback-footer-button');
    if (feedbackButton) {
      if (!showFeedbackTab) {
        $(feedbackButton).css('visibility', 'hidden');
      }
      feedbackButton.onclick = () => {
        handleOpenFeedbackModal();
      };
    }
    const feedbackButtonInt = document.getElementById('feedback-footer-button-international');
    if (feedbackButtonInt) {
      if (!showFeedbackTab) {
        $(feedbackButtonInt).css('visibility', 'hidden');
      }
      feedbackButtonInt.onclick = () => {
        handleOpenFeedbackModal();
      };
    }
  }, []);

  if (!showFeedbackTab) {
    return null;
  }

  const showFeedbackButton = siteFormat === 'desktop' || siteFormat === 'tablet';

  const triggerGeneralFeedbackModal = passedAppFunctions.triggerGeneralFeedbackModal;

  return (
    <>
      {!hideContainer && showFeedbackButton && (
        <FeedbackButton suppressHydrationWarning={true} handleOpenFeedbackModal={handleOpenFeedbackModal} />
      )}
      {open && (
        <FeedbackModal
          siteFormat={siteFormat}
          feedbackModalOpen={open}
          handleOpenFeedbackModal={handleOpenFeedbackModal}
          store={state.contentData?.store}
          isStoreFeedback={isStoreFeedback}
          triggerPushSurvey={triggerGeneralFeedbackModal}
          handleGeneralFeedback={passedAppFunctions.handleGeneralFeedback}
        />
      )}
      {triggerGeneralFeedbackModal && (
        <PopUpSurvey
          siteFormat={siteFormat}
          popUpSurveyOpen={triggerGeneralFeedbackModal}
          handleOpenFeedbackModal={handleOpenFeedbackModal}
          store={state.contentData?.store}
          isStoreFeedback={isStoreFeedback}
          triggerPushSurvey={triggerGeneralFeedbackModal}
          handleGeneralFeedback={passedAppFunctions.handleGeneralFeedback}
        />
      )}
    </>
  );
}
